import React from 'react';

import {LanguageViewModel} from "../../../domain/locale/models/language/language.view-model";
import {LanguageMenuModuleItem} from "./language-menu-module.item";

export const LanguageMenuModuleItems = ({controller}) => {
  const {state: {menuModel}} = controller;
  const {collapsedItems} = menuModel;

  return collapsedItems.map((language: LanguageViewModel) => <LanguageMenuModuleItem
      key={language.id}
      language={language}
      controller={controller}
    />
  )
};